import { FieldArray, FormikProps, FormikProvider } from "formik"

import { useGetPaymentConditionsQuery } from "../../../../pages/Finance/FinanceServices"
import FileUploader from "../../../../pages/Projects/features/RaiseTicketForm/common/FileUploader/FileUploader"
import Checkbox from "../../../Checkbox/Checkbox"
import InputTag from "../../../Input/InputTag"
import MultiSelectDropdown from "../../../MultiSelectDropdown/MultiSelectDropdown"
import RadioGroup from "../../../RadioGroup/RadioGroup"
import SearchInputV2 from "../../../SearchInputV2/SearchInputV2"

import error_mark from "../../../../assets/images/error_mark.svg"
import styles from "./PaymentTerms.module.scss"

export enum CONDITIONS {
    ALREADY_PAID_AS_ADVANCE = "Already paid as advance",
    OTHER_CONDITION = "Other conditions",
}

export enum PAYMENT_TYPE {
    SET_CONDITIONAL_TIME_FRAME = "Set conditional time frame",
    SET_CUSTOM_DATE = "Set custom date",
}

const PAYMENT_TYPE_OPTIONS = [
    { id: 0, title: PAYMENT_TYPE.SET_CUSTOM_DATE },
    { id: 1, title: PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME },
]

const PaymentTerm = ({
    count,
    removeHandler,
    id,
    data,
    paymentTermsFormik,
}: {
    count: number
    id: string
    data: any
    removeHandler: () => void
    paymentTermsFormik: FormikProps<any>
}) => {
    const showError = paymentTermsFormik.submitCount > 0

    const { data: paymentConditions } = useGetPaymentConditionsQuery({
        ticket_id: "",
    })

    return (
        <div className={styles.payment_container}>
            <div className={styles.heading_container}>
                <div className={styles.heading}>PAYMENT TERM {count}</div>
                {count !== 1 && (
                    <div
                        onClick={() => {
                            removeHandler()
                        }}
                        className={styles.remove}>
                        Remove
                    </div>
                )}
            </div>
            <div
                className={styles.section}
                style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "10px" }}>
                <RadioGroup
                    options={PAYMENT_TYPE_OPTIONS}
                    onSelect={(value: any) => {
                        paymentTermsFormik.setFieldValue(`payment_terms_obj[${id}].pmt_type`, value)
                    }}
                    value={data.pmt_type}
                />
                {showError && !data.pmt_type?.title && <img src={error_mark} alt="" />}
            </div>
            {data.pmt_type?.title && (
                <>
                    <div className={`${styles.section} ${styles.section_1}`}>
                        {data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME ? (
                            <>
                                <div className={styles.subsection_1}>
                                    <SearchInputV2
                                        additionalValidation="1"
                                        type="number"
                                        onSearch={(value: string) => {
                                            paymentTermsFormik.setFieldValue(
                                                `payment_terms_obj[${id}].pmt_percent`,
                                                value
                                            )
                                        }}
                                        value={data.pmt_percent}
                                        placeholder={0}
                                        height="24px"
                                        error={!data.pmt_percent}
                                        showError={showError}
                                    />
                                </div>
                                <div className={styles.subsection_2}>% of total to be paid within</div>
                                <div className={styles.subsection_3}>
                                    <SearchInputV2
                                        additionalValidation="5"
                                        type="number"
                                        onSearch={(value: any) => {
                                            paymentTermsFormik.setFieldValue(`payment_terms_obj[${id}].time_qty`, value)
                                        }}
                                        value={data.time_qty}
                                        placeholder={0}
                                        height="24px"
                                        error={
                                            data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                                            !data.time_qty
                                        }
                                        showError={data.time_qty !== 0 && showError}
                                    />
                                </div>
                                <div className={styles.subsection_4}>
                                    <MultiSelectDropdown
                                        // fontsize="12px"
                                        title="Days"
                                        options={[
                                            { id: 1, title: "Days" },
                                            { id: 2, title: "Weeks" },
                                            { id: 3, title: "Months" },
                                        ]}
                                        id="Days"
                                        onChange={() => {}}
                                        selectedOptions={data.time_uom?.title ? [data.time_uom] : []}
                                        selectionType={"single"}
                                        onSelect={(value: any) => {
                                            paymentTermsFormik.setFieldValue(`payment_terms_obj[${id}].time_uom`, value)
                                        }}
                                        height="24px"
                                        error={
                                            data.pmt_type?.title === "Set conditional time frame" &&
                                            !data.time_uom?.title
                                        }
                                        showError={showError}
                                        // disabled={freezeField("payment_terms")}
                                    />
                                </div>
                                <div className={styles.subsection_5}>
                                    <MultiSelectDropdown
                                        // fontsize="12px"
                                        title="Select Condition"
                                        options={
                                            paymentConditions?.map(item => ({ id: item.id, title: item.name })) || []
                                        }
                                        id="Other Condition"
                                        onChange={() => {}}
                                        selectedOptions={data.condition?.title ? [data.condition] : []}
                                        selectionType={"single"}
                                        onSelect={(value: any) => {
                                            paymentTermsFormik.setFieldValue(
                                                `payment_terms_obj[${id}].condition`,
                                                value
                                            )
                                        }}
                                        height="24px"
                                        error={
                                            data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                                            !data.condition?.title
                                        }
                                        showError={showError}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className={styles.subsection_1}>
                                    <SearchInputV2
                                        additionalValidation="1"
                                        type="number"
                                        onSearch={(value: any) => {
                                            paymentTermsFormik.setFieldValue(
                                                `payment_terms_obj[${id}].pmt_percent`,
                                                value
                                            )
                                        }}
                                        value={data.pmt_percent}
                                        placeholder={0}
                                        height="24px"
                                        error={!data.pmt_percent}
                                        showError={showError}
                                    />
                                </div>
                                <div className={styles.subsection_2}>% of total to be paid by</div>
                                <div>
                                    <InputTag
                                        placeholder="Enter Date"
                                        type="date"
                                        useCustomDate={true}
                                        value={data.pmt_due_date}
                                        name="pmt_due_date"
                                        onChange={(e: any) =>
                                            paymentTermsFormik.setFieldValue(
                                                `payment_terms_obj[${id}].pmt_due_date`,
                                                e.target.value
                                            )
                                        }
                                        style={{
                                            border:
                                                showError && data.pmt_type?.id == 0 && !data.pmt_due_date?.length
                                                    ? "1px solid red"
                                                    : "",
                                        }}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    {data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                        data.condition?.title === CONDITIONS.OTHER_CONDITION && (
                            <div className={`${styles.section} ${styles.section_2}`}>
                                <SearchInputV2
                                    onSearch={(value: any) => {
                                        paymentTermsFormik.setFieldValue(
                                            `payment_terms_obj[${id}].condition_text`,
                                            value
                                        )
                                    }}
                                    value={data.condition_text}
                                    placeholder={"Enter Payment Term*"}
                                    height="36px"
                                    error={
                                        data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                                        data.condition?.title === CONDITIONS.OTHER_CONDITION &&
                                        !data.condition_text
                                    }
                                    showError={showError}
                                    // disabled={freezeField("payment_terms")}
                                />
                            </div>
                        )}
                    {data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                        data.condition?.title === CONDITIONS.ALREADY_PAID_AS_ADVANCE && (
                            <div className={styles.advance_payment_wrapper}>
                                <div className={`${styles.advance_payment_container}`}>
                                    <SearchInputV2
                                        containerClass={styles.input_container}
                                        onSearch={(value: any) => {
                                            paymentTermsFormik.setFieldValue(`payment_terms_obj[${id}].utr`, value)
                                        }}
                                        value={data.utr}
                                        placeholder={"UTR Number*"}
                                        height="36px"
                                        error={
                                            data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                                            data.condition?.title === CONDITIONS.ALREADY_PAID_AS_ADVANCE &&
                                            !data.utr
                                        }
                                        showError={showError}
                                        // disabled={freezeField("payment_terms")}
                                    />
                                    <SearchInputV2
                                        type="number"
                                        containerClass={styles.input_container}
                                        onSearch={(value: any) => {
                                            paymentTermsFormik.setFieldValue(
                                                `payment_terms_obj[${id}].original_amt`,
                                                value
                                            )
                                        }}
                                        value={data.original_amt}
                                        placeholder={"Original Amount*"}
                                        height="36px"
                                        error={
                                            data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                                            data.condition?.title === CONDITIONS.ALREADY_PAID_AS_ADVANCE &&
                                            !data.original_amt
                                        }
                                        showError={showError}
                                    />
                                    <InputTag
                                        containerClass={styles.input_container}
                                        placeholder="Due Date of Payment*"
                                        type="date"
                                        useCustomDate={true}
                                        value={data.txn_due_date}
                                        name="txn_due_date"
                                        onChange={e => {
                                            paymentTermsFormik.setFieldValue(
                                                `payment_terms_obj[${id}].txn_due_date`,
                                                e.target.value
                                            )
                                        }}
                                        showError={showError}
                                        error={
                                            data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                                            data.condition?.title === CONDITIONS.ALREADY_PAID_AS_ADVANCE &&
                                            !data.txn_due_date
                                        }
                                    />
                                    <InputTag
                                        containerClass={styles.input_container}
                                        placeholder="Actual Date of Payment*"
                                        type="date"
                                        useCustomDate={true}
                                        value={data.paid_at}
                                        name="paid_at"
                                        onChange={(e: any) => {
                                            paymentTermsFormik.setFieldValue(
                                                `payment_terms_obj[${id}].paid_at`,
                                                e.target.value
                                            )
                                        }}
                                        showError={showError}
                                        error={
                                            data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                                            data.condition?.title === CONDITIONS.ALREADY_PAID_AS_ADVANCE &&
                                            !data.paid_at
                                        }
                                    />
                                </div>
                                <div className={styles.advance_payment_container}>
                                    <SearchInputV2
                                        type="number"
                                        containerClass={styles.input_container}
                                        onSearch={(value: any) => {
                                            paymentTermsFormik.setFieldValue(
                                                `payment_terms_obj[${id}].net_deduction`,
                                                value
                                            )
                                        }}
                                        value={data.net_deduction}
                                        placeholder={"Net Deduction*"}
                                        height="36px"
                                        error={
                                            data.pmt_type?.title === PAYMENT_TYPE.SET_CONDITIONAL_TIME_FRAME &&
                                            data.condition?.title === CONDITIONS.ALREADY_PAID_AS_ADVANCE &&
                                            !data.net_deduction
                                        }
                                        showError={showError}
                                        // disabled={freezeField("payment_terms")}
                                    />
                                    <SearchInputV2
                                        containerClass={styles.input_container}
                                        onSearch={(value: any) => {
                                            paymentTermsFormik.setFieldValue(`payment_terms_obj[${id}].remarks`, value)
                                        }}
                                        value={data.remarks}
                                        placeholder={"Remarks"}
                                        height="36px"
                                        showError={false}
                                        // disabled={freezeField("payment_terms")}
                                    />
                                    <FileUploader
                                        containerClass={`${styles.input_container} ${styles.file_uploader}`}
                                        onChange={e => {
                                            paymentTermsFormik.setFieldValue(
                                                `payment_terms_obj[${id}].evidence_file`,
                                                e
                                            )
                                        }}
                                        title="Upload Evidence File*"
                                        total={1}
                                        hideTooltip={true}
                                        accept="image/png, image/gif, image/jpeg,.jpg,.pdf,application/pdf"
                                        error={showError && !data.evidence_file}
                                        showError={showError}
                                        // disabled={freezeField("payment_terms")}
                                        uploadedCount={data.evidence_file ? 1 : 0}
                                    />
                                </div>
                            </div>
                        )}
                </>
            )}
            <div
                className={`${styles.section} ${styles.section_3}`}
                onClick={() => {
                    paymentTermsFormik.setFieldValue(`payment_terms_obj[${id}].bank_guarantee`, !data.bank_guarantee)
                }}>
                <Checkbox checked={data.bank_guarantee} />
                <div className={styles.section_text}>via collection of Bank Guarantee</div>
            </div>
        </div>
    )
}

const PaymentTerms = ({ states }: any) => {
    let error =
        states.paymentTermsFormik.values.payment_terms_obj?.reduce(
            (acc: any, obj: any) => acc + parseFloat(obj.pmt_percent),
            0
        ) !== 100

    return (
        <FormikProvider value={states.paymentTermsFormik}>
            <div className={`${styles.container} ${error ? styles.error : ""} mx-20`}>
                <div>
                    <FieldArray
                        name="payment_terms_obj"
                        render={arrayHelpers => (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-20">
                                    <div className="section_header">Payment Terms</div>
                                    <div
                                        className={styles.cta}
                                        onClick={() => arrayHelpers.push(states.PAYMENT_TERMS_INITIAL_VALUES)}>
                                        + Add new
                                    </div>
                                </div>
                                {states.paymentTermsFormik.values.payment_terms_obj?.map((item: any, index: any) => {
                                    return (
                                        <PaymentTerm
                                            key={index}
                                            paymentTermsFormik={states.paymentTermsFormik}
                                            count={index + 1}
                                            data={item}
                                            removeHandler={() => {
                                                arrayHelpers.remove(index)
                                            }}
                                            id={index}
                                        />
                                    )
                                })}
                            </>
                        )}
                    />
                </div>
            </div>
            {error ? (
                <div className="px-20 error_text">
                    Please note that the sum of the % of allocation should be equal to 100% for all Payment terms to
                    move forward.
                </div>
            ) : null}
        </FormikProvider>
    )
}

export default PaymentTerms
